<template>
  <div class="image-grid">
    <div  v-for="pic in photos" v-bind:key="pic.id" data-type="image" :class="'layout-'+pic.layout">
      <a @click="clic(pic)" :class="'img img-'+pic.img">
        <imageitem :source="pic.id"></imageitem>
      </a>
    </div>
  </div>
</template>

<script>

import imageitem from './image.vue'

export default {

components: { imageitem },

  props: {
    photos: Array
  },

  methods: {
    clic(p) {
      this.$emit('clicked', p)
    }
  }
}

</script>

<style scoped>

.image-grid {
  overflow: hidden;
  width: calc(100% + 6px);
  margin-left: -3px;
}

.image-grid > div {
  float: left;
  margin-bottom: 6px;
  padding-left: 3px;
  padding-right: 3px;
  position: relative;
}

.image-grid .layout-full {
  width: 100%;
}

.image-grid .layout-half {
  width: 50%;
}

.image-grid .img {
  position: relative;
  width: 100%;
  height: 0;
  background: linear-gradient(#f9f9f9, #fff);
  transition: opacity 200ms ease;
  outline: none !important;
}

.image-grid .img:hover {
  cursor: pointer;
  opacity: 0.95;
}

.image-grid .img-square {
  padding-bottom: 100%;
}

.image-grid .img-vertical {
  padding-bottom: calc(150% + 12px);
}

.image-grid .img-horizontal {
  padding-bottom: 50%;
}

.image-grid a {
  display: block;
}

/*
img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  max-width: 100%;
  width: 100%;
  vertical-align: middle;

  -o-object-fit: cover;
  object-fit: cover;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);

  -o-object-position: 50% 50%;
  object-position: 50% 50%;
  border: 0;
}
*/

</style>
